import React, { useState, useEffect } from 'react';
import './styles.css';
import Card from '../Card';
import "./styles.css";
import ItemList, { Item, UiColumn, UiColumn2 } from '../ItemList/indexOld';
import axios from "axios";
import useAppData from '@/store/useAppData';
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import useRouter from '@/store/useRouter';
import { useShallow } from "zustand/shallow";
import FloatingActions, { FloatingAction } from '../FloatingActions';
import { RouterStoreItemKey } from '@/store/useRouter/types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faArrowLeft, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { AG_GRID_LOCALE_CZ } from '@ag-grid-community/locale';
import NewInventoryCard from '../NewInventory';
import { exportItemsToTablePdf, TableColumn, urlToDataUrl } from '@/Utils/exportInventoryResultToPdf';
import { ExcelColumn, exportItemsToExcel } from '@/Utils/exportInventoryResultToExcel';
import logoAirlines from "../Login/logoAirlines.png";
import DialogWindow from '../DialogWindow';

export interface InventoryItem {
    id: number;
    date?: string;
    stockId?: string;
    completed?: boolean;
    description?: string;
}

const myTheme = themeQuartz.withParams({
    fontSize: 17,
    headerFontSize: 17,
    rowHeight: 55,
    headerHeight: 48,
});

const Inventory2 = () => {

    const selectedStock = useAppData(state => state.selectedStock);

    const router = useRouter(
        useShallow(state => ({
            go: state.go,
            history: state.history
        }))
    );

    const columnsPrintInventory: TableColumn<Item>[] = [
        { header: "Id", field: "id", widthMm: 18 },
        { header: "Název", field: "name", widthMm: 80 },
        { header: "Stav", field: "state", widthMm: 18 },
        { header: "Kolekce", field: "list1", widthMm: 22 },
        { header: "Pohlaví", field: "list2", widthMm: 18 },
        { header: "Velikost", field: "list3", widthMm: 18 },
        { header: "Zkontrolováno", field: "inventoryDate", widthMm: 28 },
        { header: "Aktuální", field: "quantity", widthMm: 16, align: "right" },
        { header: "Puvodní", field: "oldQuantity", widthMm: 16, align: "right" },
        { header: "Rozdíl", field: "diffQuantity", widthMm: 16, align: "right" }
    ];

    const columnsExcel = [
        { header: "Id", field: "id", width: 10, type: "text" },
        { header: "Název", field: "name", width: 35, type: "text" },
        { header: "Stav", field: "state", width: 12, type: "text" },
        { header: "Kolekce", field: "list1", width: 14, type: "text" },
        { header: "Pohlaví", field: "list2", width: 12, type: "text" },
        { header: "Velikost", field: "list3", width: 12, type: "text" },
        { header: "Inventura", field: "inventoryDate", width: 22, type: "date" },
        { header: "Počet", field: "quantity", width: 10, type: "number", align: "right" },
        { header: "Puvodní", field: "oldQuantity", width: 10, type: "number", align: "right" },
        { header: "Rozdíl", field: "diffQuantity", width: 10, type: "number", align: "right" }
    ] satisfies readonly ExcelColumn<Item>[];

    const columns: UiColumn2<Item>[] = [
        { field: "id", headerName: "Id", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "name", headerName: "Název", flex: 3, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "state", headerName: "Stav", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "list1", headerName: "Kolekce", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "list2", headerName: "Pohlaví", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "list3", headerName: "Konfekční velikost", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        {
            field: "inventoryDate",
            headerName: "Zkontrolováno",
            flex: 2,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        { field: "quantity", headerName: "Počet", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true, editable: true },
        {
            headerName: "Kontrola",
            field: "check",
            flex: 1,
            minWidth: 140,
            //filter: false,
            //sortable: false,
            cellRenderer: (params: any) => (
                <button
                    type="button"
                    className="inventory-check-btn"
                    onClick={async () => {
                        await updateInventoryDate(params.data.id);
                        getStockItems();
                        setFirstId(null);
                    }}
                >
                    Zkontrolovat
                </button>
            ),
        },
    ]

    const [stocksItemsState, setStocksItemsState] = React.useState<Item[] | null>([]);
    const [firstIdState, setFirstId] = React.useState<string | null>(null);
    const [selectedInventoryState, setSelectedInventoryState] = React.useState<InventoryItem | null>(null);
    const selectedInventoryBuffer = React.useRef<InventoryItem | null>(null);
    const [inventoriesState, setInventoriesState] = React.useState<InventoryItem[]>([]);
    const [displayNewInventoryForm, setDisplayNewInventoryForm] = React.useState<boolean>(false);
    const [showFinishDialog, setShowFinishDialog] = useState(false);
    const [showNoCheckedItemsDialog, setShowNoCheckedItemsDialog] = useState(false);
    const [isFinishing, setIsFinishing] = useState(false);
    const gridApiRef = React.useRef(null);
    const colApiRef = React.useRef(null);
    const [showNotFinishedInventoryDialog, setShowNotFinishedInventoryDialog] = useState<boolean>(false);
    const [notFinishedInventoryText, setsNotFinishedInventoryText] = useState<string>("");

    const columnsCompletedInventory: UiColumn2<Item>[] = [
        { field: "id", headerName: "Id", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "name", headerName: "Název", flex: 3, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "state", headerName: "Stav", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "list1", headerName: "Kolekce", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "list2", headerName: "Pohlaví", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "list3", headerName: "Konfekční velikost", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        {
            field: "inventoryDate",
            headerName: "Zkontrolováno",
            flex: 1,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        { field: "quantity", headerName: "Aktuální", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true, editable: !selectedInventoryBuffer?.current?.completed },
        { field: "oldQuantity", headerName: "Původní", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "diffQuantity", headerName: "Rozdíl", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true }
    ]

    const actions: FloatingAction[] = [
        {
            key: "3",
            label: "Zpět",
            icon: <FontAwesomeIcon icon={faArrowLeft} />,
            onClick: () => router.go({ key: RouterStoreItemKey.LISTITEMS }),
        },
        ...(selectedInventoryBuffer?.current && !selectedInventoryBuffer?.current?.completed
            ? [
                {
                    key: "1",
                    label: "Ukončit inventuru",
                    icon: <FontAwesomeIcon icon={faFloppyDisk} />,
                    onClick: () => onSaveCheck()
                },
            ]
            : []),
    ];

    const SCAN_CHAR_MAX_INTERVAL = 40;
    const SCAN_SEQUENCE_TIMEOUT = 120;
    const SCAN_MIN_LENGTH = 1;

    type ScanType = "rfid" | "barcode" | "unknown";

    const scanBufferRef = React.useRef<string>("");
    const scanTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
    const lastKeyTimeRef = React.useRef<number>(0);
    const lastCharRef = React.useRef<string>("");
    const isScannerSequenceRef = React.useRef<boolean>(false);
    const scannerTargetRef = React.useRef<EventTarget | null>(null);
    const scannerInitialValueRef = React.useRef<string | null>(null);

    const classifyScan = (rawCode: string): ScanType => {
        const code = rawCode.trim();

        if (!code) return "unknown";

        if (/^\d{1,5}$/.test(code)) {
            const n = parseInt(code, 10);
            if (n >= 1 && n <= 50000) {
                return "barcode";
            }
        }

        if (/^[\p{L}0-9+]+$/u.test(code)) {
            return "rfid";
        }

        return "unknown";
    };

    const handleBarcodeScan = async (itemId: number) => {
        try {
            await getStockItems(String(itemId));
        } catch (err) {
            console.error("Failed to handle barcode scan", err);
        }
    };

    const dateFormat = (date: string, dateOnly?: boolean) => {
        const d = new Date(date);

        const pad = (n: number) => String(n).padStart(2, "0");

        if (dateOnly) {
            return (
                pad(d.getDate()) + "." +
                pad(d.getMonth() + 1) + "." +
                d.getFullYear()
            );
        } else {
            return (
                pad(d.getDate()) + "." +
                pad(d.getMonth() + 1) + "." +
                d.getFullYear() + " " +
                pad(d.getHours()) + ":" +
                pad(d.getMinutes()) + ":" +
                pad(d.getSeconds())
            );
        }
    };

    const handleScanCompleted = async (rawCode: string) => {
        let code = rawCode.trim();
        code = fixChipCode(code);
        if (!code) return;

        const type = classifyScan(code);
        console.log("Scan done:", { code, type });

        switch (type) {
            case "rfid":
                break;
            case "barcode":
                await handleBarcodeScan(parseInt(code, 10));
                break;
            case "unknown":
            default:
                console.warn("Unknown scan format:", code);
                break;
        }
    };

    const fixChipCode = (str) => {
        if (!str) {
            return str;
        }

        const charMap = {
            "é": "0",
            "+": "1",
            "ě": "2",
            "š": "3",
            "č": "4",
            "ř": "5",
            "ž": "6",
            "ý": "7",
            "á": "8",
            "í": "9"
        };

        return str.split("").map(char => charMap[char] || char).join("");
    }

    useEffect(() => {
        const handleGlobalKeyDown = (e: KeyboardEvent) => {
            const key = e.key;

            if (key.length !== 1) {
                lastCharRef.current = "";
                return;
            }

            const now = performance.now();
            const diff = now - lastKeyTimeRef.current;
            lastKeyTimeRef.current = now;

            const target = e.target as HTMLInputElement | HTMLTextAreaElement | HTMLElement;

            if (!isScannerSequenceRef.current) {
                if (diff > 0 && diff < SCAN_CHAR_MAX_INTERVAL && lastCharRef.current) {
                    isScannerSequenceRef.current = true;
                    scannerTargetRef.current = target;

                    if (target && "value" in target) {
                        const t = target as HTMLInputElement | HTMLTextAreaElement;
                        const currentValue = t.value;
                        const initial =
                            currentValue.endsWith(lastCharRef.current)
                                ? currentValue.slice(0, -lastCharRef.current.length)
                                : currentValue;

                        scannerInitialValueRef.current = initial;
                        t.value = initial;
                    } else {
                        scannerInitialValueRef.current = null;
                    }

                    scanBufferRef.current = lastCharRef.current + key;

                    e.preventDefault();
                    e.stopPropagation();
                } else {
                    lastCharRef.current = key;
                    return;
                }
            } else {
                e.preventDefault();
                e.stopPropagation();
                scanBufferRef.current += key;
            }

            if (scanTimerRef.current) {
                clearTimeout(scanTimerRef.current);
            }

            scanTimerRef.current = setTimeout(() => {
                const fullCode = scanBufferRef.current;
                scanBufferRef.current = "";
                isScannerSequenceRef.current = false;

                const t = scannerTargetRef.current as any;
                if (t && scannerInitialValueRef.current !== null && "value" in t) {
                    t.value = scannerInitialValueRef.current;
                }

                scannerTargetRef.current = null;
                scannerInitialValueRef.current = null;
                lastCharRef.current = "";

                if (fullCode.length >= SCAN_MIN_LENGTH) {
                    void handleScanCompleted(fullCode);
                }
            }, SCAN_SEQUENCE_TIMEOUT);
        };

        window.addEventListener("keydown", handleGlobalKeyDown);

        return () => {
            window.removeEventListener("keydown", handleGlobalKeyDown);
        };
    }, []);

    useEffect(() => {
        const loadData = async () => {
            if (selectedStock) {
                await getInventories(selectedStock.id);

            } else {
                setInventoriesState([]);
                selectedInventoryBuffer.current = null;
            }
        };

        loadData();
    }, [selectedStock]);


    useEffect(() => {
        const loadData = async () => {
            if (selectedInventoryBuffer.current?.id) {
                await getStockItems();
            }
        };

        loadData();
    }, [selectedInventoryBuffer.current]);

    useEffect(() => {
        if (!firstIdState) return;

        const t = setTimeout(() => {
            requestAnimationFrame(() => {
                focusAndEditById(firstIdState, "quantity");
            });
        }, 50);

        return () => clearTimeout(t);
    }, [firstIdState]);

    const getStockItems = async (firstId?: string | null) => {
        try {
            console.log();
            const res = await (
                axios({
                    method: "post",
                    url: "/api/inventory/getItems",
                    data: {
                        start: 0,
                        end: 100000,
                        stockId: selectedStock.id,
                        inventoryId: selectedInventoryBuffer.current?.id,
                        inventoryOrder: true,
                        firstId: firstId,
                        inventoryCompleted: selectedInventoryBuffer.current?.completed
                    }
                })
            );

            setStocksItemsState(res.data.stocksItems);
            if (firstId) {
                setFirstId(firstId);
            }
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const getInventories = async (stockId: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "/api/inventory/getAll",
                    data: {
                        stockId: stockId
                    }
                })
            );

            if (res.data.inventory && res.data.inventory.length > 0) {
                setInventoriesState(res.data.inventory);
                selectedInventoryBuffer.current = res.data.inventory[0];
                setSelectedInventoryState(res.data.inventory[0]);
                return res.data.inventory;
            } else {
                setInventoriesState([]);
                selectedInventoryBuffer.current = null;
                return [];
            }
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const updateQauntity = async (id: string, quantity: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventory/updateQuantity",
                data: {
                    id: id,
                    quantity: quantity,
                    inventoryId: selectedInventoryBuffer.current?.id,
                    stockId: selectedStock?.id
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update stock item", err);
            throw err;
        }
    };

    const updateInventoryDate = async (id: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventory/updateInventoryDate",
                data: {
                    id: id,
                    inventoryId: selectedInventoryBuffer.current?.id,
                    stockId: selectedStock?.id
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory item", err);
            throw err;
        }
    };

    const updateInventoryDate2 = async (inventoryId: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventory/updateInventoryDate2",
                data: {
                    inventoryId: inventoryId
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory item", err);
            throw err;
        }
    };

    const updateInventorySetCompleted = async (inventoryId: string, completed: boolean) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventory/setCompleted",
                data: {
                    id: inventoryId,
                    completed: completed
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory item", err);
            throw err;
        }
    };

    const handleCellValueChanged = async (params: any) => {
        const { colDef, data, oldValue, newValue, value } = {
            colDef: params.colDef,
            data: params.data,
            oldValue: params.oldValue,
            newValue: params.newValue,
            value: params.value,
        };

        if (colDef.field === 'quantity') {

            if (newValue) {
                await updateQauntity(data.id, newValue);
                getStockItems();
                setFirstId(null);

                console.log('Row id:', data.id);
                console.log('Old:', oldValue, 'New:', newValue);
            }
        }
    };

    const onSaveCheck = async () => {

        const noCheckedItems = stocksItemsState.filter(stockItem => stockItem.oldQuantity > 0 && !stockItem.inventoryDate);

        if (noCheckedItems.length > 0) {
            setShowNoCheckedItemsDialog(true);
        } else {
            setShowFinishDialog(true);
        }
    }

    const onSave = async () => {

        if (selectedInventoryBuffer.current?.id) {
            await updateInventoryDate2(selectedInventoryBuffer.current?.id);
            await updateInventoryQuantityToStockItems(selectedInventoryBuffer.current?.id);
            const updateInventoryId = await updateInventorySetCompleted(String(selectedInventoryBuffer.current?.id/*selectedInventoryState?.id*/), true);
            const newInventories = await getInventories(selectedStock?.id);
            const selectedInventory = newInventories.filter(inventory => inventory.id == Number(updateInventoryId))[0];
            selectedInventoryBuffer.current = selectedInventory;
            setSelectedInventoryState(selectedInventory);
            getStockItems();
        }
    }

    const onClickNewInventory = () => {
        const notCompletedInventories = inventoriesState.filter(inventory => inventory.completed === false);
        if (notCompletedInventories.length > 0) {
            const notCompletedInventory = notCompletedInventories[0];
            setsNotFinishedInventoryText(`Existuje nedokončená inventura: ${notCompletedInventory.description} (${dateFormat(notCompletedInventory.date, true)})`);
            setShowNotFinishedInventoryDialog(true);
        } else {
            setDisplayNewInventoryForm(true);
        }
    };

    const onClickPrintInventory = async () => {

        if (selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed && stocksItemsState) {
            const stockItemsToPrint = stocksItemsState
                .filter(stockItem => !(stockItem.quantity === 0 && stockItem.oldQuantity === 0 && !stockItem.inventoryDate))
                .map(stockItem => ({
                    ...stockItem,
                    name: stripDiacritics(stockItem?.name),
                }));

            const logoBase64 = await urlToDataUrl(logoAirlines);

            exportItemsToTablePdf<Item>(stockItemsToPrint, columnsPrintInventory, {
                title: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)})` : "Inventura",
                fileName: `${selectedInventoryBuffer.current?.description ? `${dateFormat(selectedInventoryBuffer.current?.date, true)} ${selectedInventoryBuffer.current?.description}` : "Inventura"}.pdf`,
                fontSize: 9,
                logoDataUrl: logoBase64,
                logoFormat: "PNG",
                logoWidthMm: 30,
                logoHeightMm: 20,
                userName: "Admin"
            });
        }
    };

    const onClickPrintExcelInventory = async () => {

        if (selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed && stocksItemsState) {
            const stockItemsToPrint = stocksItemsState
                .filter(stockItem => !(stockItem.quantity === 0 && stockItem.oldQuantity === 0 && !stockItem.inventoryDate))
                .map(stockItem => ({
                    ...stockItem,
                    name: stripDiacritics(stockItem?.name),
                }));

            const logoBase64 = await urlToDataUrl(logoAirlines);
            await exportItemsToExcel<Item>(stockItemsToPrint, columnsExcel, {
                title: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)})` : "Inventura",
                fileName: `${selectedInventoryBuffer.current?.description ? `${dateFormat(selectedInventoryBuffer.current?.date, true)} ${selectedInventoryBuffer.current?.description}` : "Inventura"}.xlsx`,
                sheetName: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)})` : "Inventura",
                logoBase64,
                logoExt: "png",
                userName: "Admin"
            });
        }
    };

    const onClickPrintNotCheckedExcelInventory = async () => {

        if (selectedInventoryBuffer.current && !selectedInventoryBuffer.current?.completed && stocksItemsState) {
            const stockItemsToPrint = stocksItemsState
                .filter(stockItem =>  stockItem.oldQuantity > 0 && !stockItem.inventoryDate)
                .map(stockItem => ({
                    ...stockItem,
                    name: stripDiacritics(stockItem?.name),
                }));

            await exportItemsToExcel<Item>(stockItemsToPrint, columnsExcel, {
                title: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)}) Nezkontrolované položky` : "Inventura_Nezkontrolované_Položky",
                fileName: `${selectedInventoryBuffer.current?.description ? `${dateFormat(selectedInventoryBuffer.current?.date, true)}_${selectedInventoryBuffer.current?.description}__Nezkontrolované_Položky` : "Inventura_Nezkontrolované_Položky"}.xlsx`,
                sheetName: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)}) Nezkontrolované položky` : "Inventura_Nezkontrolované_Položky"
            });
        }
    };

    function stripDiacritics(text: string) {
        return text
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
    }

    const onSaveNewInventory = async (newInventoryId: string) => {
        console.log("New inventory150");
        console.log(newInventoryId);

        setDisplayNewInventoryForm(false);
        const newInventories = await getInventories(selectedStock?.id);

        if (newInventoryId) {
            const newInventory = newInventories.filter(inventory => inventory.id == Number(newInventoryId))[0];
            selectedInventoryBuffer.current = newInventory;
            setSelectedInventoryState(newInventory);
        } else {

            if (newInventories.length > 0) {
                const newInventory = newInventories[0];
                selectedInventoryBuffer.current = newInventory;
                setSelectedInventoryState(newInventory);
            } else {
                selectedInventoryBuffer.current = null;
                setSelectedInventoryState(null);
            }
        }
    };

    const updateInventoryQuantityToStockItems = async (inventoryId: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventory/applyInventoryToStock",
                data: {
                    inventoryId: inventoryId
                },
            });

            return res.data?.ok;
        } catch (err) {
            console.error("Failed to update applyInventoryToStockItems", err);
            throw err;
        }
    };

    const onGridReady = (params) => {
        gridApiRef.current = params.api;
        colApiRef.current = params.columnApi;
    };

    function focusAndEditById(rowId, colKey) {
        const api = gridApiRef.current;
        if (!api) return;

        const node = api.getRowNode(String(rowId));
        if (!node) return;

        const rowIndex = 0;

        api.setFocusedCell(rowIndex, colKey);
        api.startEditingCell({ rowIndex, colKey });
    }

    return (displayNewInventoryForm ? (
        <NewInventoryCard onSave={onSaveNewInventory}></NewInventoryCard>
    ) : (<>
        {showNotFinishedInventoryDialog &&
            <DialogWindow
                displayDialog={showNotFinishedInventoryDialog}
                setDisplayDialog={setShowNotFinishedInventoryDialog}
                title={notFinishedInventoryText}
                cancelText={"OK"}
            />
        }
        {showFinishDialog && (
            <div className="inv-modal-overlay" onMouseDown={() => setShowFinishDialog(false)}>
                <div
                    className="inv-modal"
                    onMouseDown={(e) => e.stopPropagation()}
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="inv-modal-title">Opravdu si přejete dokončit inventuru?</div>

                    <div className="inv-modal-actions1">
                        <button
                            type="button"
                            className="inv-btn"
                            disabled={isFinishing}
                            onClick={async () => {
                                setShowFinishDialog(false);
                                await onSave();
                            }}
                        >
                            Ano
                        </button>

                        <button
                            type="button"
                            className="inv-btn"
                            disabled={isFinishing}
                            onClick={() => setShowFinishDialog(false)}
                        >
                            Ne
                        </button>
                    </div>
                </div>
            </div>
        )}
        {showNoCheckedItemsDialog && (
            <div className="inv-modal-overlay" onMouseDown={() => setShowNoCheckedItemsDialog(false)}>
                <div
                    className="inv-modal"
                    onMouseDown={(e) => e.stopPropagation()}
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="inv-modal-title">Byly zjištěny položky, které by měly být skladem, ale nebyly zkontrolovány. Přejete si přesto pokračovat?</div>

                    <div className="inv-modal-actions">
                        <div className="inv-modal-actions-left">
                            <button
                                type="button"
                                className="inv-btn"
                                onClick={onClickPrintNotCheckedExcelInventory}
                            >
                                Nezkontrolované položky (Excel)
                            </button>
                        </div>

                        <div className="inv-modal-actions-right">
                            <button
                                type="button"
                                className="inv-btn"
                                disabled={isFinishing}
                                onClick={async () => {
                                    setShowNoCheckedItemsDialog(false);
                                    await onSave();
                                }}
                            >
                                Ano
                            </button>

                            <button
                                type="button"
                                className="inv-btn"
                                disabled={isFinishing}
                                onClick={() => setShowNoCheckedItemsDialog(false)}
                            >
                                Ne
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        <Card
            title="Inventura"
        >
            <div className="inventory-toolbar">
                <div className="inventory-toolbar-left">
                    <select className="inventory-select"
                        value={selectedInventoryBuffer.current?.id}
                        onChange={(e) => {

                            const selectedInventory = inventoriesState.filter(inventoryItem => inventoryItem.id == Number(e.target.value));
                            if (selectedInventory.length > 0) {
                                selectedInventoryBuffer.current = selectedInventory[0];
                                setSelectedInventoryState(selectedInventory[0]);
                            } else {
                                selectedInventoryBuffer.current = null
                                setSelectedInventoryState(null);
                                setStocksItemsState([]);
                            }
                        }}
                    >
                        <option value="">Vyberte inventuru</option>
                        {inventoriesState.map(inventory => <option value={inventory.id}>{`${dateFormat(inventory.date, true)} ${inventory.description}`}</option>)}
                    </select>

                    {selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed && <span className="inventory-status inventory-status--done">
                        Dokončeno
                    </span>}

                    {selectedInventoryBuffer.current && !selectedInventoryBuffer.current.completed && <span className="inventory-status inventory-status--undone">
                        Nedokončeno
                    </span>}

                </div>

                <div className="inventory-toolbar-right">
                    {selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed &&
                        <button
                            type="button"
                            className="inventory-new-btn"
                            onClick={onClickPrintExcelInventory}
                        >
                            Excel
                        </button>}

                    {selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed &&
                        <button
                            type="button"
                            className="inventory-new-btn"
                            onClick={onClickPrintInventory}
                        >
                            PDF
                        </button>}

                    <button
                        type="button"
                        className="inventory-new-btn"
                        onClick={onClickNewInventory}
                    >
                        Nová inventura
                    </button>
                </div>
            </div>
            <div className="item-list-grid-wrapper">
                <AgGridReact
                    theme={myTheme}
                    columnDefs={selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed ? columnsCompletedInventory : columns}
                    rowData={stocksItemsState}
                    onCellValueChanged={handleCellValueChanged}
                    pagination={false}
                    getRowStyle={(params) => {
                        if (firstIdState && params.data?.id == firstIdState) {
                            return {
                                backgroundColor: "#ffe680"
                            };
                        }

                        return null;
                    }}
                    localeText={AG_GRID_LOCALE_CZ}
                    onGridReady={onGridReady}
                />
            </div>

            {
                actions?.length ? (
                    <div className="item-list-actions">
                        <FloatingActions actions={actions} />
                    </div>
                ) : null
            }
        </Card ></>));
};

export default Inventory2;